import React, { useEffect } from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { useLayout } from '../../../context';
/**
 * @deprecated - please use IA config to define layouts.
 * {@link https://checkout.atlassian.net/wiki/spaces/HUBV/pages/7053869259/Dashboard+Config+Structure}
 */
export const LayoutRoute = ({ isFullPage = false, ...props }) => {
    const { setIsFullPage } = useLayout();
    const match = useRouteMatch(props);
    useEffect(() => {
        if (match && match.isExact) {
            setIsFullPage(isFullPage);
        }
        return () => setIsFullPage(false);
    }, [setIsFullPage, isFullPage, match]);
    return React.createElement(Route, { ...props });
};
